//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[1,"EndDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"ExtendOffset",1,0],[0,"GuideCurve",1,"Section",0],[0,"LocationOption",1,0],[0,"NumberOfPoints",1,0],[1,"OffsetDistance",0,"Expression",0],[0,"RespacePoints",1,0],[0,"ReverseDirection",1,0],[1,"Section1",0,"Section",0],[1,"Section2",0,"Section",0],[1,"Section3",0,"Section",0],[1,"Section4",0,"Section",0],[1,"Spacing",0,"Expression",0],[0,"SpacingMethod",1,0],[0,"SpacingOption",1,0],[1,"StartDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0]],[[[],"CreateGuideCurves",{},0,0],[["numCurves","guideCurves","instanceGuideCurves"],"GetGuideCurves",{},0,0],[[],"RediscoverGuideEnds",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.JointmarkGuideBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.JointmarkGuideBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.JointmarkGuideBuilder.Location = Object.freeze({
    "CenterLine" : "CenterLine", "OffsetFromEdge" : "OffsetFromEdge", "ExistingCurve" : "ExistingCurve"});

SPLM.Weld.JointmarkGuideBuilder.SpaceMethod = Object.freeze({
    "ArcLength" : "ArcLength", "ParallelXPlane" : "ParallelXPlane", "ParallelYPlane" : "ParallelYPlane", "ParallelZPlane" : "ParallelZPlane"});

SPLM.Weld.JointmarkGuideBuilder.SpaceOption = Object.freeze({
    "Distance" : "Distance", "Number" : "Number", "MinimumDistance" : "MinimumDistance"});

export default SPLM;